import { ApiError } from '@bemor/web-kit';
import type { FieldValues, UseFormReturn } from 'react-hook-form';

/** The service names the cents field; the form shows dollars. Returns true when a 422 landed on a field. */
export function applyMoneyErrors<T extends FieldValues>(
    form: UseFormReturn<T>,
    error: unknown,
    map: Record<string, string> = { amount_cents: 'amount' },
): boolean {
    if (!ApiError.is(error) || error.status !== 422) return false;
    let applied = false;
    for (const item of error.errors) {
        if (item.field && item.message) {
            form.setError((map[item.field] ?? item.field) as never, {
                type: 'server',
                message: item.message,
            });
            applied = true;
        }
    }
    return applied;
}
